const BASE_LABEL_COLORS = [
  'green',
  'yellow',
  'orange',
  'red',
  'purple',
  'blue',
  'sky',
  'lime',
  'pink',
  'black',
  null,
];

const LABEL_COLORS = BASE_LABEL_COLORS.reduce((acc, color) => {
  if (!color) {
    return [...acc, color];
  }
  return [...acc, `${color}_light`, color, `${color}_dark`];
}, []);

const compareLabels = (a, b) =>
  LABEL_COLORS.indexOf(a.color) - LABEL_COLORS.indexOf(b.color) ||
  (a.name || '').localeCompare(b.name || '');

module.exports = { compareLabels };
